import React, { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../services/firebaseConfig";
import { JitsiMeeting } from "@jitsi/react-sdk";

import css from "./Pro.module.css";
import { UserContext } from "../../context/UserContext";
import { Head } from "../../utils/Head";

export const ProMeetingDetails = () => {
  const { userData } = useContext(UserContext);
  const { id } = useParams();
  const navigate = useNavigate();
  const [meeting, setMeeting] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notes, setNotes] = useState("");
  const [showJitsi, setShowJitsi] = useState(false);

  useEffect(() => {
    async function fetchMeeting() {
      try {
        const docRef = doc(db, "meetings", id);
        const snapshot = await getDoc(docRef);
        if (snapshot.exists()) setMeeting(snapshot.data());
        else navigate("/participant");
      } catch (error) {
        console.error("Erro:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchMeeting();
  }, [id, navigate]);

  async function handleOpenMeeting() {
    await updateDoc(doc(db, "meetings", meeting.id), {
      moderatorOnline: true,
    });
    const jitsiURL = `https://meet.jit.si/${meeting.jitsiRoomName}`;
    window.open(jitsiURL, "_blank");
  }

  async function handleFinishMeeting() {
    await updateDoc(doc(db, "meetings", meeting.id), {
      status: "done",
      notes: notes,
      moderatorOnline: false,
    });
    alert("Reunião concluída!");
    navigate("/prouser");
  }

  if (loading) return <p>Carregando...</p>;
  if (!meeting) return <p>Reunião não encontrada.</p>;

  if (showJitsi && meeting) {
    return (
      <div className={css.jitsiContainer}>
        <JitsiMeeting
          roomName={meeting.jitsiRoomName}
          configOverwrite={{
            prejoinPageEnabled: false,
            enableLobby: false,
          }}
          interfaceConfigOverwrite={{
            SHOW_JITSI_WATERMARK: false,
          }}
          getIFrameRef={(node) => (node.style.height = "100vh")}
          userInfo={{
            displayName: "Moderador",
          }}
        />
      </div>
    );
  }

  return (
    <div className={css.container}>
      <Head
        title={meeting.title}
        description="Detalhes da reunião profissional"
      />

      <h2>{meeting.title}</h2>
      <p className={css.subtitle}>
        {new Date(meeting.scheduleFor).toLocaleDateString("pt-BR", {
          weekday: "long",
          day: "2-digit",
          month: "2-digit",
          year: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        })}
      </p>

      {meeting.participants.map((p) => (
        <span key={p} className={css.subtitle}>
          {p},{" "}
        </span>
      ))}

      {!showJitsi && (
        <button className="saveButton" onClick={() => handleOpenMeeting()}>
          Abrir Sala
        </button>
      )}

      <div className={css.notesSection}>
        <label>Notas pós-reunião:</label>
        <textarea
          className={css.notes}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder="Registre observações ou próximos passos..."
        />
        <button className="saveButton" onClick={handleFinishMeeting}>
          Encerrar e salvar
        </button>
      </div>
    </div>
  );
};
